import { useEffect } from "react";

export default function OilGasSolutions() {
  useEffect(() => {
    window.location.replace("/oil-and-gas-solutions-CORRECT.html");
  }, []);

  return null;
}
